import React, { useEffect, useState } from 'react';
import Logo from '../assets/Images/logo.png';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as CallIcon } from '../assets/icons/call-icon.svg';
import { ReactComponent as EmailIcon } from '../assets/icons/email-icon.svg';
import { ReactComponent as MapIcon } from '../assets/icons/map.svg';
import { ReactComponent as InstagramIcon } from '../assets/icons/instagram.svg';
import { ReactComponent as LinkedInIcon } from '../assets/icons/linkdin.svg';
import CounterTopdivider from '../assets/Images/layered-wave.svg';
import { BASE_URL, GET_CONTACTLIST } from '../ApiUrl';
import axios from 'axios';

const Footer = () => {

    const [contactlist, setcontactlist] = useState();

    const handlecontactlist = async () => {
        try {
            const result = await axios.get(BASE_URL + GET_CONTACTLIST);
            setcontactlist(result.data.contactlist);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    };

    useEffect(() => {
        handlecontactlist();
    }, []);

    const { about } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [about]);
    return (
        <footer>
            <div className="divider-top">
                <img src={CounterTopdivider} alt="shape-divider-bottom" width="100%"
                    height="auto" />
            </div>
            <div className="container">
                <div className="row mt-4">
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <Link to="/">
                            <div className="d-flex align-items-center justify-content-start">
                                <img src={Logo} className="brand" alt="logo" width="100%" height="100%" />
                            </div>
                        </Link>
                        <p className="f-para">Experience Customer-centric Approach Product Development Contract Manufacturing Export Assistance</p>
                        <div className='d-flex align-items-center gap-2 my-3'>
                            {/* Social Media Icons can be added here */}
                            <a href="https://www.linkedin.com/company/avna-pvt-ltd/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className='social-icon'>
                                <LinkedInIcon />
                            </a>
                            <a href="https://www.instagram.com/avnapvtltd/?hl=en" target="_blank" rel="noopener noreferrer" className='social-icon'>
                                <InstagramIcon />
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="footer-widget">
                            <h5 className="footer-widget-title">Services</h5>
                            <ul>
                                <li className="link"><Link to="/about" onClick={() => window.scrollTo(0, 0)}>Export Assistance </Link></li>
                                <li className="link"><Link to="/about" onClick={() => window.scrollTo(0, 0)}>Product Development</Link></li>
                                <li className="link"><Link to="/about" onClick={() => window.scrollTo(0, 0)}>Contract Manufacturing </Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="footer-widget">
                            <h5 className="footer-widget-title">Quick links</h5>
                            <ul>
                                <li className="link"><Link to="/">Home</Link></li>
                                <li className="link"><Link to="/about">About</Link></li>
                                <li className="link"><Link to="/blogs">Blogs</Link></li>
                                <li className="link"><Link to="/products">Products</Link></li>
                                <li className="link"><Link to="/contact">Contact</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="footer-widget">
                            <h5 className="footer-widget-title">Contact</h5>
                            {
                                contactlist?.map((value, index) => {
                                    return (
                                        <Link key={index} className="cursor icon-box call mb-3" to={`tel:${value.phone}`}>
                                            <span>
                                                <CallIcon />
                                            </span>
                                            {value.phone}
                                        </Link>
                                    );
                                })
                            }

                            {
                                contactlist?.map((value, index) => {
                                    return (
                                        <Link key={index} className="cursor icon-box" to={`mailto:${value.email}`}>
                                            <span>
                                                <EmailIcon />
                                            </span>
                                            {value.email}
                                        </Link>
                                    );
                                })
                            }
                            <h5 className="footer-widget-title mt-4">Address</h5>
                            {
                                contactlist?.map((value, index) => {
                                    return (
                                        <Link key={index} className="icon-box" to={`https://www.google.com/maps/search/${encodeURIComponent(value.locations)}`} target='_blank'>
                                            <span>
                                                <MapIcon />
                                            </span>
                                            {value.locations}
                                        </Link>
                                    );
                                })
                            }

                            

                        </div>
                        <div>
                                <iframe
                                    src="https://www.google.com/maps?q=Avna+Private+Limited&output=embed"
                                    width="300"
                                    height="130"
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Google Map"
                                    className='fotter-map'
                                ></iframe>
                            </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <p>Design & Developed by
                    <Link to="https://inspirefox.com/" target='_blank'> InspireFox  </Link>
Copyright © 2025 <Link to='/'>AVNA</Link>. All Rights Reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
